import React from 'react';
import {
  bool,
  func,
  number,
  oneOfType,
  arrayOf,
  oneOf,
  shape,
  string
} from 'prop-types';
import { Calculator } from '@thd-olt-component-react/calculator';
import { BuyboxTooltip } from './BuyboxTooltip/BuyboxTooltip';
import * as calculatorHelper from '../BuyboxCalcHelper';
import { SUBCLASSWALLPAPER } from '../../constants';
import '../buybox.scss';

const BuyboxCalculator = ({
  showTooltip,
  addAdditional,
  channel,
  quantity,
  pricing,
  info,
  fulfillment,
  installServices,
  specificationGroup,
  onChangeCalculator,
  updateAdditionalQuantity
}) => {

  const calculatorProps = calculatorHelper.getCalculatorProps({
    fulfillment,
    installServices,
    pricing,
    info,
    specificationGroup
  });
  if (!calculatorProps || !calculatorProps?.unitsPerCase) {
    return null;
  }
  const {
    calculatorType,
    lineItemName,
    dimensionNames,
    uom,
    uomPlural,
    caseUnitOfMeasure,
    productCategory,
    unitsPerCase
  } = calculatorProps || {};
  const wallpaperCalc = info?.subClassNumber === SUBCLASSWALLPAPER;
  return (
    <>
      <Calculator
        calculatorType={calculatorType}
        lineItemName={lineItemName}
        dimensionNames={dimensionNames}
        productCategory={productCategory}
        unitsPerCase={unitsPerCase}
        addAdditional={addAdditional}
        maxAreaNumber={wallpaperCalc ? 8 : 3}
        onCalculate={onChangeCalculator}
      />
      {showTooltip && (
        <div className="tooltip__actions">
          <BuyboxTooltip
            uom={uom}
            uomPlural={uomPlural}
            unitsPerCase={unitsPerCase}
            caseUnitOfMeasure={caseUnitOfMeasure}
            addAdditional={addAdditional}
            quantity={quantity}
            pricing={pricing}
            onChange={updateAdditionalQuantity}
          />
        </div>
      )}
    </>
  );
};

BuyboxCalculator.propTypes = {
  showTooltip: bool,
  addAdditional: bool,
  channel: oneOf(['desktop', 'mobile']),
  quantity: oneOfType([string, number]),
  pricing: shape({
    bulkPrice: number,
    bulkPriceThresholdQty: number,
    originalPrice: number,
    specialPrice: number
  }),
  info: shape({
    subClassNumber: string,
    projectCalculatorEligible: bool,
    calculatorType: string
  }),
  specificationGroup: arrayOf(shape({
    specTitle: string,
    specifications: arrayOf(shape({
      specName: string,
      specValue: string
    }))
  })),
  fulfillment: shape({
    backordered: bool
  }),
  installServices: shape({
    scheduleAMeasure: bool
  }),
  onChangeCalculator: func,
  updateAdditionalQuantity: func
};

BuyboxCalculator.defaultProps = {
  showTooltip: false,
  addAdditional: true,
  channel: 'desktop',
  quantity: 1,
  pricing: {},
  info: null,
  fulfillment: null,
  installServices: null,
  specificationGroup: null,
  onChangeCalculator: () => {},
  updateAdditionalQuantity: () => {}
};

export { BuyboxCalculator };
